/* eslint-disable @typescript-eslint/naming-convention */
import { google } from '../../../proto/protobuf';

export type DecodeableProperties = google.protobuf.IAny;
export interface DecodedProperties {
  readonly type_url?: google.protobuf.IAny['type_url'];
  readonly value?: Record<string, unknown>;
  readonly error?: string;
}

type DecodeEventSpecificProperties = (protobuf: unknown, properties: DecodeableProperties) => DecodedProperties;

export const decodeEventSpecificProperties: DecodeEventSpecificProperties = (protobuf, properties) => {
  const { type_url, value } = properties;

  if (!type_url) {
    return {
      type_url,
      error: 'Cannot decode event properties with missing type_url',
    };
  }

  const identifiers = type_url.split('/')[1].split('.');
  const namespace = identifiers[0];
  const className = identifiers[1];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const events = (protobuf as any)[namespace];
  const eventClass = events ? events[className] : undefined;

  if (!eventClass) {
    return {
      type_url,
      error: `There was a problem looking up the class for ${type_url}. The class may not exist.`,
    };
  }

  if (!eventClass.decode) {
    return {
      type_url,
      error: `There was a problem with the class for ${type_url}. Decode function is not loaded`,
    };
  }

  return {
    type_url,
    value: eventClass.decode(value),
  };
};
